import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, signal, Signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CityLink } from '../../models/city-link.interface';
import { CityEnum, CityNames } from '../../models/city.enum';
import { MatCardModule } from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SeoService } from '../../services/seo.service';
import { firstValueFrom } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-city-links',
  standalone: true,
  imports: [CommonModule, MatCardModule, MatListModule, MatProgressSpinnerModule],
  templateUrl: './city-links.component.html',
  styleUrls: ['./city-links.component.scss'],
})
export class CityLinksComponent implements OnInit {
  @Input() set cityId(value: CityEnum) {
    this._cityId = value;
    this.cityName.set(CityNames[value]);
    // Recharger les liens quand l'ID change
    this.loadCityLinks();
  }
  get cityId(): CityEnum {
    return this._cityId;
  }
  
  private _cityId!: CityEnum;
  cityName = signal<string>('');
  
  cityLinks = signal<CityLink[]>([]);
  loading = signal<boolean>(false);
  error = signal<string | null>(null);

  constructor(
    private seoService: SeoService,
    private languageService: TranslateService
  ) {}

  async ngOnInit() {
    // On ne charge plus les liens ici car le setter de cityId s'en charge
  }

  private async loadCityLinks() {
    this.loading.set(true);
    this.error.set(null);
    const currentLang = this.languageService.currentLang;

    try {
      const res = await firstValueFrom(this.seoService.getCityLinks(this.cityId.toString(), currentLang));
      if (res && res.length > 0) {
        this.cityLinks.set(res);
      } else {
        const message = this.languageService.instant('CITY_LINKS.NO_LINKS_FOUND', { city: this.cityName() });
        this.error.set(message);
      }
    } catch (err) {
      console.error('Erreur lors du chargement des liens:', err);
      const message = this.languageService.instant('CITY_LINKS.ERROR_LOADING_LINKS', { city: this.cityName() });
      this.error.set(message);
    } finally {
      this.loading.set(false);
    }
  }
}
